import { Injectable } from '@angular/core';
import { PreviousCampaignsModel } from './previous-campaigns-model';

@Injectable({
  providedIn: 'root'
})

export class PreviousCampaignsModelAdapter {

  adapt(item: any): PreviousCampaignsModel {
    return new PreviousCampaignsModel(item);
  }
  
  createEmpty(){
    return new PreviousCampaignsModel({
      TriggerId: 0,
      MessageName: '',
      ListName: '',
      SentSMSsScheduledDate: '',
      MessageId: 0,
      MessageType: 0,
      ReportId: 0
    });
  }
}